import { Modal } from 'src/components';
import styled from 'styled-components';

const DeleteModalStyle = styled(Modal)`
  &.modal-delete {
    .text-content {
      margin-bottom: 30px;
      color: #000000;
    }
  }
`;

export default DeleteModalStyle;
